export const darkTheme = {
    // bg: '#25262a',
    bg: '#0a192f',
    text: '#fff',
    green: '#54d9bd',
    grey: '#ccd6f6',
    darkGrey: '#8892b0',
    para: '#7b86a4',
    bg2: '#0a192f',
    textbg: '#54d9bd',
    navbg: '#0a192f'
};
export const lightTheme = {
    // bg: '#54d9bd',
    bg: '#0a192f',
    // text: '#64ffda',
    textbg: '#7b86a4',
    green: '#54d9bd',
    navbg: '#0a192f'
};